import { createFileRoute } from '@tanstack/react-router'
import { MemoryManager } from '../../../../components/MemoryManager'

export const Route = createFileRoute('/desa/$slug/dashboard/memory')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <MemoryManager desaId={desaId} />
  },
})
